import React from "react";

import { useRegisterFormContext } from "@pages/register/hooks/useRegisterFormContext";
import { ContactDetailsForm } from "@pages/register/steps/UserDetails/ContactDetailsForm";

export const ContactDetails = ({
  isCreatedUserCompletingRegistration,
}: {
  isCreatedUserCompletingRegistration?: boolean;
}) => {
  const { control, errors, handleCheckboxChange, isBeneficiary, isArtist } = useRegisterFormContext();
  return (
    <ContactDetailsForm
      control={control}
      errors={errors}
      handleCheckboxChange={handleCheckboxChange}
      isBeneficiary={isBeneficiary}
      isArtist={isArtist}
      isCreatedUserCompletingRegistration={isCreatedUserCompletingRegistration}
    />
  );
};
